import { GetCaseExportDownloadUrlDocument, PreviewCaseExportFileNameDocument } from "generated/graphql";
import { runGqlQuery } from "gqlClient";
import { triggerDownloadWithUrl } from "helpers/triggerDownload";
import { enqueueSnackbar } from "notistack";

export type CaseBrowserTab = "review" | "profile" | "documents" | "";

export const triggerCaseExportDownload = (caseId: number, caseExportId: number): void => {
  runGqlQuery(GetCaseExportDownloadUrlDocument, { caseId, caseExportId })
    .then((r) => triggerDownloadWithUrl(r.case.exports.getExportDownloadUrl.url))
    .catch(() => {
      enqueueSnackbar("Error downloading case export", { variant: "error" });
    });
};

export const getCaseExportFileNamePreview = async (
  caseId: number,
  lensId: number,
  configName: string,
  maybeFileNameTemplate: string | undefined,
  fileExtension: string
): Promise<string> => {
  return runGqlQuery(PreviewCaseExportFileNameDocument, {
    caseId,
    lensId,
    configName,
    maybeFileNameTemplate,
    fileExtension,
  }).then((r) => r.case.exports.previewCaseExportFileName);
};
